import { Menu, MenuItem } from "@material-ui/core";
import React, { useState } from "react";
import { DeleteTwoTone, EditTwoTone } from "@material-ui/icons";
import { ReactComponent as SurveyIcon } from "../../assets/svg/survey-icon.svg";
import { NotificationManager } from "react-notifications";
import { getStateLoginComplete } from "../../containers/LayoutHome/stateLogin";

const MenuManageEvents = ({
  idManageEvents,
  item,
  anchorSelected,
  anchorEl,
  setAnchorEl,
  setAnchorSelected,
  handleEditEvent,
  handleCloseActions,
  setOpenDeleteModal,
  identity,
  handleCreateSurveyFromTemplate,
}) => {
  const validateCreateSurvey = () => {
    if (identity === "event-list" || identity === "event-list-coach") {
      try {
        let date = new Date();
        let eventDate = new Date(item?.finishDate);
        return date > eventDate;
      } catch (error) {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
        return false;
      }
    }
  };

  const getDeleteButtonState = (id, item) => {
    if (id === "site-list" || id === "lob-list") {
      return item.statusId;
    } else if (id === "coaches-list") {
      return item.coachState === "Active" ? true : false;
    } else if (id === "event-list" || id === "event-list-coach") {
      return item.eventState.toLowerCase() === "active";
    }
    return false;
  };
  return (
    <Menu
      id="long-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorSelected === idManageEvents ? true : false)}
      keepMounted
      transition={"true"}
      onClose={() => handleCloseActions()}
    >
      <MenuItem
        hidden={identity === "site-list"}
        onClick={() => {
          setAnchorEl(null);
          setAnchorSelected(null);
          handleEditEvent(item);
          // setopenDeleteModal(rowData)
        }}
      >
        <EditTwoTone />
        &nbsp; Edit
      </MenuItem>
      <MenuItem
        disabled={getDeleteButtonState(identity, item)}
        onClick={() => {
          setAnchorEl(null);
          setAnchorSelected(null);
          setOpenDeleteModal(item);
        }}
      >
        <DeleteTwoTone />
        &nbsp; Delete
      </MenuItem>
      {validateCreateSurvey() && (
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setAnchorSelected(null);
            handleCreateSurveyFromTemplate(item);
          }}
        >
          <SurveyIcon />
          &nbsp; Create survey from template
        </MenuItem>
      )}
    </Menu>
  );
};

export default MenuManageEvents;
